<template>
  <sModal
    v-model="open"
    :content-class-name="dialog_class"
    :data-qa="dataQa"
    :title="label"
    @close="$emit('close')">
    <template v-slot:activator="{ visible: show }">
      <slot
        name="activator"
        :show="show"
        v-on="open = true"/>
    </template>
    <div>
      <slot name="actions"/>
      <slot name="after_actions"/>
      <slot name="card_text"/>
    </div>
    <template #footer>
      <div
        key="footer"
        class="flex flex-between items-center">
        <div class="flex">
          <slot name="first_col"/>
        </div>
        <div class="flex">
          <slot name="second_col"/>
        </div>
      </div>
    </template>
  </sModal>
</template>
<script>
export default {
  name: 'dialogTemplateWithFooterToolkit',
  data() {
    return {}
  },
  methods: {},
  computed: {
    open: {
      get() {
        return this.dialog
      },
      set(value) {
        if (value) { this.$emit('open') }
        this.$emit('update:dialog', value)
      }
    },
  },
  components: {},
  created() {},
  props: {
    dialog: Boolean,
    dataQa: String,
    label: String,
    dialog_class: String,
  },
}
</script>
